import axios from 'axios';

const api = axios.create({
    baseURL: 'https://lovepets.herokuapp.com'
})

export default api;